import { CoreLink } from '@uncinc/react-drupal-core';
import React, { useRef } from 'react';

import './style.scss';
import { Lottie } from "@uncinc/uncinc-react-kitchen-sink";
import classnames from 'classnames';

const Dossier = ({ className, name, image, imageAlt = '', imageBundle = null, type, link = null, body = null, small }) => {
  const lottieAnimation = useRef(null);
  className = `Dossier ${className || ''}`;

  const classNames = classnames(className, {
    'Dossier--small': small
  });
  return (
    <div className={classNames}>
      <CoreLink href={link}>
        {!small && (
          <div className="Dossier__image">
            {imageBundle === 'lottie' ? (
              <Lottie
                id={image}
                path={image}
                onInit={(lottie) => lottieAnimation.current = lottie}
                loop
                autoPlay
                startPosition={0}

              />
            ) : (
              <img src={image} alt={imageAlt} />
            )}

          </div>
        )}
        <div className="Dossier__info">
          {small && image && (
            <img src={image} alt={imageAlt} />
          )}
          <div className="Dossier__info__text">
            {type && (
              <div className="Dossier__info__type">{type}</div>
            )}

            {body && (
              <div className="Dossier__info__text">{body}</div>
            )}
          </div>

          {link && (
            <div className="Dossier__info__link">{name} <i className="icon icon-after icon-arrow-right" /></div>
          )}
        </div>
      </CoreLink>
    </div>
  );
};

export default Dossier;
